export const ADCUBE_ENTITY = {
  COMPANY: "company",
  ADVERTISER: "advertiser",
  PROJECT: "project",
  ITEM: "item",
  CAMPAIGN: "campaign",
  ADGROUP: "adgroup",
  USER: "user",
};
